import * as yup from "yup";
import { ARTIST_PASSWORD_FORMAT } from "../../models/artist";

/**
 * Validation schema of the form that sets a new password after the link from the mail.
 */
export const createResetPasswordSchema = () =>
    yup.object().shape({
        newPassword: yup
            .string()
            .matches(ARTIST_PASSWORD_FORMAT, { message: { key: "YUP.ERROR.PASSWORD_FORMAT" } })
            .required(),
        newPasswordConfirmation: yup
            .string()
            .oneOf([yup.ref("newPassword")], { key: "YUP.ERROR.PASSWORD_DIFFERS" })
            .required(),
    });
